export enum SkyConfirmType {
  Custom = 0,
  OK = 1,
  YesCancel = 2,
  YesNoCancel = 3
}
